import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { Table } from "../../../features/Table";
import { type C5PdfPageSelection, columns } from "./columns";
import {
  type FilterC5PdfPageSelectionSchema,
  C5PdfPageSelectionFilter,
} from "./filter";

export const C5PdfPageSelectionTable = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation("tables");
  const client = searchParams.get("client") || Clients.C5;
  const table_name = Tables.C5_PDF_PAGE_SELECTION;

  return (
    <Table<C5PdfPageSelection, FilterC5PdfPageSelectionSchema>
      label={t("c5_pdf_page_selection.title", { defaultValue: "PDF page selection" })}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<C5PdfPageSelectionFilter />}
      disable_translations_request={true}
      columnVisibilityInit={{
        tableau_view: false,
        tableau_workbook_id: false,
        created_at: false,
      }}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
